import { Entity } from '@data-client/rest';
class EncryptionAttachmentEntity extends Entity {
    constructor() {
        super(...arguments);
        this.encryptionId = 0;
        this.extension = null;
        this.name = null;
        this.partitionType = null;
        this.size = null;
    }
    pk() {
        return btoa(JSON.stringify(this));
    }
}
EncryptionAttachmentEntity.key = 'EncryptionAttachment';
export { EncryptionAttachmentEntity };
